// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loginPanel .title{\r\n    display: none;\r\n}\r\n.panelContent .qrcode{\r\n    margin-top: 0;\r\n    width: 210px;\r\n    height: 210px;\r\n}\r\n.panelContent .info{\r\n    display: none;\r\n}", ""]);
// Exports
module.exports = exports;
